export default "<span class=\"status-badge {{tagStyle}}\">{{labelName}}</span>\r\n";